import { handleError } from './error-handler';

const headers = {

}

const generateUrl = (path, params) => {
    let url;

    url = new URL(path);

    if(params) {
        // add the params if there are any
        Object.keys(params).forEach((key) => {
            if (Array.isArray(params[key])) {
                params[key].forEach(element => url.searchParams.append(`${key}\[\]`, element));
            } else url.searchParams.append(key, params[key]);
        })
    }

    return url.toString();
}

// Existing callers log failures and receive undefined; rejectErrors opts in to caller-owned handling.
const doFetch = async (url, params, options = {}) => {
    try {
        const request = await fetch(url, params);
        const response = await request.json().catch(error => {
            // Successful endpoints must return valid JSON. Error pages may contain HTML or no body;
            // in that case keep the HTTP failure instead of masking it with a JSON parsing error.
            if (request.ok) {
                throw error;
            }
            return null;
        });

        if (!request.ok)  {
            if (options.rejectErrors) {
                // Preserve status and API details for internal handling, not direct user-facing text.
                const error = new Error(`Request failed: ${request.status}`);
                error.status = request.status;
                error.response = response;
                throw error;
            }
            // Preserve the numeric status expected by the existing central error-handler.
            throw request.status;
        }

        return response;
    } catch (error) {
        if (options.rejectErrors) {
            // The caller also receives AbortError so it can finish its own request lifecycle silently.
            throw error;
        }
        if (error?.name === 'AbortError') {
            // Replacing a pending request is intentional and should not be logged as a failure.
            return;
        }
        handleError(error);
    }
};

// Keep the existing argument positions intact; only callers using the fifth argument opt in.
export const get = async (path, params, signal, inspector, options = {}) => {
    const url = generateUrl(path, params);

    return doFetch(url, {
        method: 'GET',
        headers,
        params,
        signal
    }, options);
}

// Match GET's optional error handling while preserving existing POST argument positions.
export const post = async (path, data, params, signal, inspector, options = {}) => {
    const url = generateUrl(path, params);
    const body = JSON.stringify(data);

    return await doFetch(url, {
        method: 'POST',
        body,
        headers: {'Content-Type': 'application/json', ...headers},
        signal
    }, options);
}

export const put = async (path, data, params, signal, inspector) => {
    const url = generateUrl(path, params);
    const body = JSON.stringify(data);

    return await doFetch(url, {
        method: 'PUT',
        body,
        headers,
        signal
    }, inspector);
}
